import styled from 'styled-components'

export const RadioGroup = styled.div<{
  isColumn?: boolean
  isReverse?: boolean
}>`
  display: flex;
  flex-direction: ${({ isColumn, isReverse }) =>
    isColumn
      ? isReverse
        ? 'column-reverse'
        : 'column'
      : isReverse
      ? 'row-reverse'
      : 'row'};
  gap: ${({ isColumn }) => (isColumn ? '8px' : '0')};

  div {
    width: 100%;
  }
`

export const InternationCard = styled.div`
  background: ${({ theme }) => theme.ds.colors.neutral50};
  border: 1px solid ${({ theme }) => theme.ds.colors.info300};
  border-radius: 8px;
  padding: 16px;
  margin-top: 8px;
`
